module.exports = __webpack_public_path__ + "static/media/icon-print.98b291dc.svg";